export default __webpack_public_path__ + "static/media/1-bottom.9cddff42.png";